import { ConstantsLagoon } from '../common/ConstantsLagoon';
import { useLagoon } from '../hooks/useLagoon';

export const getAiBioEligibility = (
  policyNumber: string,
  currentSelectedState?: string
) => {
  const featureInclusion = useLagoon('feature-inclusion')();

  const aiBioFeatureRow = featureInclusion?.find(
    (row) =>
      row.dntFeature ===
      ConstantsLagoon.FEATURE_INCLUSION_FLAGS.AI_BIO_ELIGIBILITY_STATES
  );

  if (!aiBioFeatureRow) return false;

  const { policyIds, situsState } = aiBioFeatureRow;
  if (!Array.isArray(policyIds) || !Array.isArray(situsState)) return false;
  if (!policyNumber || !currentSelectedState) return false;

  return (
    policyIds.includes(policyNumber) &&
    situsState.includes(currentSelectedState)
  );
};
